import { gql } from '@apollo/client';

export const SIGN_IN_LOGS_PAGE_QUERY = gql`
  query signInLogs(
    $userId: Int!
    $limit: Int!
    $offset: Int!
    $orderBy: String
    $orderDirection: String
    $columnFilters: [ColumnFilter!]
  ) {
    signInLogs(
      userId: $userId
      limit: $limit
      offset: $offset
      orderBy: $orderBy
      orderDirection: $orderDirection
      columnFilters: $columnFilters
    ) {
      id
      userId
      source
      createdAt
    }
    signInLogsPageInfo(userId: $userId, columnFilters: $columnFilters) {
      totalCount
    }
  }
`;

export const SIGN_IN_LOGS_QUERY = gql`
  query signInLogs($userId: Int!, $limit: Int!, $offset: Int!) {
    signInLogs(userId: $userId, limit: $limit, offset: $offset) {
      id
      userId
      source
      createdAt
    }
  }
`;
